export const UserProfileSliceKey = "user-profile";

export const ServiceAdminRole = "serviceadmin";
